import { CloseIcon } from "@/assets/icons";
import type { ModuleIntroConfig } from "@/components/onboarding/configs/getModuleConfig";
import { Divider } from "@/components/ui/Divider";
import { MESSAGE } from "@/constants/message";
import { useProductOverview } from "@/hooks/onboarding/useProductOverview";

import { OnboardingChecklist } from "./OnboardingChecklist";
import { OnboardingVideoCard } from "./OnboardingVideoCard";
import { ONBOARDING_VIDEOS } from "./videos";

type ProductOverviewPanelProps = {
  onClose: () => void;
  onStart: (code: string, intro?: ModuleIntroConfig) => void;
};

export const ProductOverviewPanel = ({
  onClose,
  onStart
}: ProductOverviewPanelProps) => {
  const { modules, progressByModuleId, isLoading, isError } =
    useProductOverview();

  const handleStart = (code: string, intro?: ModuleIntroConfig) => {
    onStart(code, intro);
    onClose();
  };

  return (
    <div className="flex max-h-[calc(100vh-120px)] w-full flex-col gap-3 overflow-y-auto p-5">
      <header className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-bold text-txtHeading">
            {MESSAGE.PRODUCT_OVERVIEW.TITLE}
          </h2>
          <p className="text-sm text-dim-gray">
            {MESSAGE.PRODUCT_OVERVIEW.DESCRIPTION}
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label={MESSAGE.PRODUCT_OVERVIEW.CLOSE}
          className="border-0 bg-transparent p-1"
        >
          <CloseIcon className="fill-dim-gray" />
        </button>
      </header>

      <Divider className="bg-white-smoke h-px w-full" />

      <OnboardingChecklist
        modules={modules}
        progressByModuleId={progressByModuleId}
        isLoading={isLoading}
        isError={isError}
        onStart={handleStart}
      />

      <section className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-bold text-txtHeading">
            {MESSAGE.PRODUCT_OVERVIEW.VIDEOS_TITLE}
          </h3>
          {/* TODO: wire up once a videos listing page/API exists. */}
          <button type="button" className="text-sm font-medium text-teal-500">
            {MESSAGE.PRODUCT_OVERVIEW.SEE_MORE}
          </button>
        </div>
        <div className="flex gap-3">
          {ONBOARDING_VIDEOS.map((video) => (
            <OnboardingVideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductOverviewPanel;
